import styled from 'styled-components';

export const CodeWrapper = styled.div`
  border: 1px solid ${(props) => props.theme.colors.stroke};
  box-sizing: border-box;
  border-radius: 4px;
`;

export const CodeFieldTitle = styled.p`
  ${(props) => props.theme.typography.label}
  color: ${(props) => props.theme.colors.muted}
`;

export const NotificationLinkWrapper = styled.div`
  svg {
    color: ${(props) => props.theme.colors.brand};
    position: relative;
    top: 6px;
  }
`;

export const ErrorWrapper = styled.div`
  margin-top: 12px;
`;
